import { render, staticRenderFns } from "./ParallaxTabReadOnly.vue?vue&type=template&id=0de00038&"
import script from "./ParallaxTabReadOnly.vue?vue&type=script&lang=js&"
export * from "./ParallaxTabReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./ParallaxTabReadOnly.vue?vue&type=style&index=0&id=0de00038&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports